import axiosInstance from "./axiosInstance";

const attendanceService = {
  mark: async (payload) => {
    try {
      const response = await axiosInstance.post("/attendance/mark", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  fetchToday: async (date) => {
    try {
      const response = await axiosInstance.get("/attendance/today", {
        params: { date },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  fetchAll: async (filters) => {
    try {
      const response = await axiosInstance.get("/attendance/all", {
        params: filters,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  fetchById: async (id) => {
    try {
      const response = await axiosInstance.get(`/attendance/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateStatus: async (payload) => {
    try {
      const response = await axiosInstance.put(
        "/attendance/status/update",
        payload
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default attendanceService;